var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Open_in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open_in",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,10.6666667 L1.33333333,10.6666667 L1.33333333,1.33333333 L6,1.33333333 L6,0 L1.33333333,0 C0.593333333,0 0,0.6 0,1.33333333 L0,10.6666667 C0,11.4 0.593333333,12 1.33333333,12 L10.6666667,12 C11.4,12 12,11.4 12,10.6666667 L12,6 L10.6666667,6 L10.6666667,10.6666667 Z M6.77039275,0 L6.77039275,1.20845921 L8.93957704,1.20845921 L3,7.14803625 L3.85196375,8 L9.79154079,2.06042296 L9.79154079,4.22960725 L11,4.22960725 L11,0 L6.77039275,0 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link_external.f1d0766f49bfda2b4c6dd6a432876e35.svg";
export { ForwardRef as ReactComponent };